"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _CubeModel = _interopRequireDefault(require("../Models/CubeModel"));
var _models = require("../../models");
var _paulCorePackage = require("paul-core-package");
var _constants = require("../../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const {
  ComponentTypes
} = _paulCorePackage.constants;
const PwhCPipes = props => {
  return /*#__PURE__*/_react.default.createElement("group", props, /*#__PURE__*/_react.default.createElement("group", null, /*#__PURE__*/_react.default.createElement(_CubeModel.default, {
    position: [0, _constants.verticalPipeSpacing, -_constants.connectCubeWidth / 2],
    args: [1, 1, _constants.connectCubeWidth],
    highlightsType: _constants.pipesTypes.chilledWater
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    position: [0, _constants.verticalPipeSpacing, -_constants.connectCubeWidth],
    scale: [1, 1, _constants.sizeOfStraightPipePerUnit * _constants.ModelWidth[ComponentTypes.PwhC]],
    rotation: [0, 0, 0],
    highlightsType: _constants.pipesTypes.chilledWater
  }), /*#__PURE__*/_react.default.createElement(_CubeModel.default, {
    position: [0, _constants.verticalPipeSpacing, -_constants.ModelWidth[ComponentTypes.PwhC]],
    args: [1, 1, _constants.connectCubeWidth],
    highlightsType: _constants.pipesTypes.chilledWater
  })), /*#__PURE__*/_react.default.createElement("group", null, /*#__PURE__*/_react.default.createElement(_CubeModel.default, {
    position: [0, 2 * _constants.verticalPipeSpacing, -_constants.connectCubeWidth / 2],
    args: [1, 1, _constants.connectCubeWidth],
    highlightsType: _constants.pipesTypes.circulation
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    position: [0, 2 * _constants.verticalPipeSpacing, -_constants.connectCubeWidth],
    scale: [1, 1, _constants.sizeOfStraightPipePerUnit * _constants.ModelWidth[ComponentTypes.PwhC]],
    rotation: [0, 0, 0],
    highlightsType: _constants.pipesTypes.circulation
  }), /*#__PURE__*/_react.default.createElement(_CubeModel.default, {
    position: [0, 2 * _constants.verticalPipeSpacing, -_constants.ModelWidth[ComponentTypes.PwhC]],
    args: [1, 1, _constants.connectCubeWidth],
    highlightsType: _constants.pipesTypes.circulation
  })), /*#__PURE__*/_react.default.createElement("group", null, /*#__PURE__*/_react.default.createElement(_CubeModel.default, {
    position: [0, 3 * _constants.verticalPipeSpacing, -_constants.connectCubeWidth / 2],
    args: [1, 1, _constants.connectCubeWidth],
    highlightsType: _constants.pipesTypes.hotWater
  }), /*#__PURE__*/_react.default.createElement(_models.TubeStraight5mModel, {
    position: [0, 3 * _constants.verticalPipeSpacing, -_constants.connectCubeWidth],
    scale: [1, 1, _constants.sizeOfStraightPipePerUnit * _constants.ModelWidth[ComponentTypes.PwhC]],
    rotation: [0, 0, 0],
    highlightsType: _constants.pipesTypes.hotWater
  }), /*#__PURE__*/_react.default.createElement(_CubeModel.default, {
    position: [0, 3 * _constants.verticalPipeSpacing, -_constants.ModelWidth[ComponentTypes.PwhC]],
    args: [1, 1, _constants.connectCubeWidth],
    highlightsType: _constants.pipesTypes.hotWater
  })));
};
var _default = exports.default = PwhCPipes;